export default "__VITE_ASSET__DPqe6e0t__"